<template>
  <v-row>
    <v-col cols="10" offset="1">
      <h3>Ihre Ergebnisse</h3>
      <ul v-if="resultObj">
        <li v-for="key of Object.keys(resultObj)" :key="key">
          <h3>{{key}}</h3>
          <template v-if="Array.isArray(resultObj[key])">
            <p v-for="item of resultObj[key]" :key="item">{{item}}</p>
          </template>
          <p v-else>{{resultObj[key]}}</p>
        </li>
      </ul>
      <v-btn color="primary" @click="createDummyPdf()" style="margin-top: 50px">PDF DOWNLOAD</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { PDFDocument, StandardFonts } from "pdf-lib";
export default {
  name: "Results",
  mounted() {
    /*let self = this;
    var oReq = new XMLHttpRequest();
    oReq.open("GET", this.$store.state.url + 'EdV_Immunitaetsbescheinigung.pdf', true);
    oReq.responseType = "arraybuffer";

    oReq.onload = function (oEvent) {
      var arrayBuffer = oReq.response; // Note: not oReq.responseText
      if (arrayBuffer) {
        var byteArray = new Uint8Array(arrayBuffer);
        self.readPDF(byteArray);
        for (var i = 0; i < byteArray.byteLength; i++) {
        }
      }
    };

    oReq.send(null); */

  },
  data() {
    return {
      fileObj: null
    }
  },
  computed: {
    resultObj() {
      if (this.$store.state.questionnaireResultsPdf && Object.keys(this.$store.state.questionnaireResultsPdf).length > 0) {
        return this.$store.state.questionnaireResultsPdf
      } else return null
    }
  },
  methods: {
    async readPDF(bytes) {
      const pdfDoc = await PDFDocument.load(bytes);
      const form = pdfDoc.getForm();
      // const nameField = form.getTextField("name");
      //Text field
      // console.log("Text field value", nameField.getText());
      console.log('DOCUMENT', pdfDoc)
      console.log('PDF FORM', form.getFields(), form.getFields()[0].getName())

    },
    async createDummyPdf() {

      // Fetch PNG image
      const pngUrl = this.$store.state.url + 'Evidenz_der_Vernunft_Signature.png'
      const pngImageBytes = await fetch(pngUrl).then((res) => res.arrayBuffer())

      const pdfDoc = await PDFDocument.create();

      // Embed the JPG image bytes and PNG image bytes
      const pngImage = await pdfDoc.embedPng(pngImageBytes)
      const pngDims = pngImage.scale(0.25)

      // Embed the Times Roman font
      const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);

      // Add a page and draw some text on it
      const page = pdfDoc.addPage([500, 600]);
      const secondPage = pdfDoc.addPage([500, 600]);
      const thirdPage = pdfDoc.addPage([500, 600]);
      const fourthPage = pdfDoc.addPage([500, 600]);
      const fifthPage = pdfDoc.addPage([500, 600]);

      // Draw the PNG image near the lower right corner of the JPG image

      page.drawImage(pngImage, {
        x: 60,
        y: 500,
        width: pngDims.width,
        height: pngDims.height,
      })

      page.setFont(timesRomanFont);
      page.drawText("Immunitätserhebung - Ihre Daten", { x: 100, y: 500, size: 20 });

      let startY = 460;
      for (let i = 0; i< Object.keys(this.resultObj).length; i++) {
        const key = Object.keys(this.resultObj)[i]
        let pageItem = page;
        if (i> 19) {
          pageItem = secondPage
        }
        if (i> 39) {
          pageItem = thirdPage
        }
        if (i> 59) {
          pageItem = fourthPage
        }
        if (i> 79) {
          pageItem = fifthPage
        }
        if (i === 20 || i === 40 || i === 60 || i === 80) {
          startY = 470
        }
        const form = pdfDoc.getForm()
        const textField = form.createTextField(key)

        if (Array.isArray(this.resultObj[key])) {
          for (let item of this.resultObj[key]) {

            let text = item;

            textField.setText(key + ": " + text)
            textField.addToPage(pageItem, {
              x: 70, y: startY,
              width: 300,
              height: 15,
            })
           startY = startY - 20
          }
        } else {
         let text= this.resultObj[key]
          textField.setText(key + ": " + text)
          textField.addToPage(pageItem, {
            x: 60, y: startY,
            width: 300,
            height: 15,
          })
          startY = startY - 20
        }
      }

      // Set all available metadata fields on the PDFDocument. Note that these fields
      // are visible in the "Document Properties" section of most PDF readers.
      pdfDoc.setTitle("Immunitätserhebung - Ihre Daten");
      pdfDoc.setCreationDate(new Date());
      pdfDoc.setModificationDate(new Date());

      // Serialize the PDFDocument to bytes (a Uint8Array)
      const pdfBytes = await pdfDoc.save();
      var blob = new Blob([pdfBytes], { type: "application/pdf" }); // change resultByte to bytes

      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Immunitätserhebung - Ihre Daten.pdf";
      link.click();
    },
  }
}
</script>

<style scoped>

</style>
